package com.patronat.top.features.venues.domain.usecase.command

data object GetVenueAssigneesCommand
